import React, { useState } from 'react'
import { Table } from '../../components/Table/Table'
import { view_icon } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';

const CancelledList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data
    const booking = location?.state?.bookings
    console.log("data", data);
    console.log("bookingsData", booking);



    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row.index + 1}</p>;
                }
            },
            {
                Header: "Booking ID",
                accessor: "booking_id",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate('/cancelled-view', {
                        state: {
                            bookingData: row?.original
                        }
                    })}>{value}</p>
                    </div>
                },
            },
            {
                Header: "Property Name",
                accessor: "property",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate("/property-view", { state: { data: row.original } })}>{value?.name}</p></div>
                },
            },
            {
                Header: "Owner name",
                accessor: "owner",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className="pointer hoverline" onClick={() => navigate("/owner-view", { state: { type: "view", id: row.original.owner_id } })}>{row?.original?.property?.owner?.name}</p></div>
                },
            },
            {
                Header: "User",
                accessor: "user",
                Cell: ({ value, row }) => {
                    return <div className="d-flex ac-jc"> <p className='pointer hoverline' onClick={() => navigate('/user-view', { state: { type: "view", id: row.original.user_id } })}>{value?.name}</p></div>
                },
            },
            {
                Header: "Type",
                accessor: "no_of_rooms",
                Cell: ({ value, row }) => {
                    return <p>{value != 0 ? "Rooms" : "Individual"}</p>;
                },
            },
            {
                Header: "Pricing",
                accessor: "total_amount",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Date",
                accessor: "created_at",
                Cell: ({ value, row }) => {
                    return <p>{moment(value).format("DD-MM-YYYY")}</p>;
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return (<button className="cust-btn susp-btn" >
                        <p className="mb-0">{value == 1 ? "Upcoming" : value == 2 ? "Check In" : value == 3 ? "Checked Out" : "Cancelled"}</p>
                    </button>)
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">

                                <button className="cust-btn "
                                    onClick={() => navigate('/cancelled-view', {
                                        state: {
                                            bookingData: row?.original
                                        }
                                    })}
                                >
                                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                </button>

                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    Bookings - Cancelled
                </h2>

            </div>


            <Table columns={columns} data={booking} />

        </div>
    )
}

export default CancelledList